module.exports = __webpack_public_path__ + "img/tab-bets-active.cd82e5d7.png";